import React from "react";

function UtilizationEntry({rank, name, value, isHighlighted}) {

    var style = "leader-entry";
    style = isHighlighted ? style + " is-highlighted" : style;

    return (

        <tr>
            <td className={`${style} number-data leader-place`}>{rank}</td>
            <td className={`${style} leader-name`}>{name}</td>
            <td className={`${style} number-data leader-value`}>{value}</td>
        </tr>

    );

}

export default UtilizationEntry;